import { render, staticRenderFns } from "./agent-player-transaction.vue?vue&type=template&id=4c1726e2&"
import script from "./agent-player-transaction.vue?vue&type=script&lang=js&"
export * from "./agent-player-transaction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports